import { useApolloClient, useLazyQuery, useSubscription } from '@apollo/client';
import { OperatorType, ToolInventorySubscriptionPayload, ToolOrder } from '@bechtel/ht-types';
import { useEffect } from 'react';
import { TOOL_ORDER_INVENTORY_UPDATED_SUBSCRIPTION } from '~/gql';
import { SEARCH_TOOL_INVENTORIES } from '~/gql/tool-inventory';
import { SEARCH_GROUPED_PARENT_INVENTORY } from '~/gql/tool-order-inventory';

export function useToolInventoryUpdate() {
  const [searchGroupedParentInventory] = useLazyQuery<{
    toolOrder: ToolOrder;
  }>(SEARCH_GROUPED_PARENT_INVENTORY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
  const [searchToolInventory] = useLazyQuery<{
    toolOrder: ToolOrder;
  }>(SEARCH_TOOL_INVENTORIES, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
  const client = useApolloClient();
  const { data: payLoadData } = useSubscription<{
    inventoryUpdated: ToolInventorySubscriptionPayload;
  }>(TOOL_ORDER_INVENTORY_UPDATED_SUBSCRIPTION);

  useEffect(() => {
    if (!payLoadData) return;
    payLoadData.inventoryUpdated.toolInventoryIds.forEach((inventoryId) => {
      if (inventoryId) client.cache.evict({ id: inventoryId });
    });
    client.cache.gc();
  }, [client, payLoadData]);

  useEffect(() => {
    if (!payLoadData) return;
    searchGroupedParentInventory({
      variables: {
        searchInput: {
          filterInput: {
            and: [
              {
                field: 'id',
                operator: OperatorType.IN,
                values: payLoadData.inventoryUpdated.toolInventoryIds,
              },
              {
                field: 'toolRoomId',
                operator: OperatorType.EQUAL,
                value: payLoadData.inventoryUpdated.toolRoomId,
              },
            ],
          },
          sortInput: [],
        },
      },
    });
    searchToolInventory({
      variables: {
        searchInput: {
          filterInput: {
            and: [
              {
                field: 'id',
                operator: OperatorType.IN,
                values: payLoadData.inventoryUpdated.toolInventoryIds,
              },
              {
                field: 'toolRoomId',
                operator: OperatorType.EQUAL,
                value: payLoadData.inventoryUpdated.toolRoomId,
              },
            ],
          },
          sortInput: [],
        },
      },
    });
  }, [payLoadData, searchGroupedParentInventory]);
}
